
















































































import SimpleMap from '../../core/components/SimpleMap.vue';
import ModalUploadCSV from './ModalUploadCSV.vue';

import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getDateFromTimestamp,
    getIdsFromList,
    removeItemsFromList,
    matchedIndexIdInArray,
    getUniqueId,
    formatDate,
    downloadFile,
    getDateFromDateFormatApi
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import DatePickerRange from '../../core/components/DatePickerRange.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Button from '../../core/components/Button.vue';
import {
    booleanFormatter,
    formattedDate,
    getOnlyDateFromTimestamp,
    nullFormatter
} from '../../core/utils/table-formatters';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import {
    MsgBox,
    Combobox,
    LoadingDialog,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import ModalManualFactor from './ModalManualFactor.vue';
import ModalVehicleCalibration from './ModalVehicleCalibration.vue';
import { config } from 'rxjs';
import moment from 'moment';
import { set } from 'tiny-cookie';

@Component({
    components: {
        Loading,
        Combobox,
        SimpleMap,
        DatePickerSingle,
        DatePickerRange,
        Button,
        SimpleTable,
        ModalManualFactor,
        DeleteConfirmation,
        ModalVehicleCalibration
    }
})
export default class CardVehicleCalibrations extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({
        default() {
            return [];
        }
    })
    calItems: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    vehicleVariables: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    cropTypes: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    companies: Array<object>;
    @Prop({ default: false }) seeAll: boolean;
    @Prop({ default: false }) saveOnMemory: boolean;
    @Prop({ default: -1 }) vehicleID: number;
    @Prop({ default: -1 }) vehicleVin: number;
    @Prop({ default: true }) canUpload: boolean;
    @Prop({ default: true }) canDelete: boolean;
    @Prop({ default: false }) disabledRow: boolean;
    sortByCalibrations: string[] = ['date'];
    sortDescCalibrations: boolean[] = [false];
    items: Array<object> = [];
    calibrationToDelete: object = {};
    loadingCalibrations: boolean = false;
    patchCalibration: object | null = {};
    manualFactorToDelete: object | null = null;
    loadingLevMap: boolean = false;
    loadingTable: boolean = false;
    viewAllType: string = '';
    levMapToDelete: object = {};
    visibleModalSettings: boolean = false;
    loadingSettings: boolean = false;
    deleteType: string = '';
    visibleModalVehicleCalibration: boolean = false;
    headersCalibrations: Array<object> = [
        {
            text: 'Fecha',
            align: 'left',
            value: 'date',
            formatter: getOnlyDateFromTimestamp
        },
        {
            text: 'Chacra',
            align: 'left',
            value: 'location.name'
        },
        {
            text: 'Ancho',
            align: 'center',
            value: 'work_width'
        },
        {
            text: 'Pasadas',
            align: 'center',
            value: 'calibration_passes.length'
        },
        // {
        //     text: 'ErrIni',
        //     align: 'center',
        //     value: '',
        // },
        // {
        //     text: 'ErrFin',
        //     align: 'center',
        //     value: '',
        // },
        {
            text: 'Telemetria',
            align: 'center',
            formatter: booleanFormatter,
            value: 'using_telemetry',
            class: 'pa-0'
        },
        {
            text: 'Aplicada',
            align: 'center',
            formatter: booleanFormatter,
            value: 'active_calibration',
            class: 'pa-0'
        },
        {
            text: 'Delay',
            align: 'center',
            value: 'delay'
        },
        {
            text: 'Equipo',
            align: 'left',
            value: 'operator'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions'
        }
    ];

    get isCarrier(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER];
    }

    mounted() {
        let self = this;
        this.$nextTick(() => {
            self.items = self.calItems;
        });
    }

    modifyCalibration(item) {
        this.$set(item, 'isLoading', true);
        this.patchCalibration = JSON.parse(JSON.stringify(item));
        this.visibilityModalCalibration(true);
        this.$set(item, 'isLoading', false);
    }

    visibilityModalCalibration(value) {
        this.visibleModalVehicleCalibration = value;
        if (!value) {
            this.patchCalibration = {};
        }
    }

    addNewCalibration(newCalibration) {
        this.loadingCalibrations = true;
        let oldItems = this.items;
        this.items = [];
        oldItems.push(newCalibration);
        setTimeout(() => {
            this.items = oldItems;
            this.loadingCalibrations = false;
            this.reloadPreviousList();
        }, 1000);
    }

    deleteAction(value) {
        if (value) {
            this.confirmationDelete = false;
            if (!this.saveOnMemory) {
                this.removeCalibration();
            } else {
                this.removeCalibrationFromList();
            }
        } else {
            this.confirmationDelete = false;
        }
    }

    removeCalibration() {
        let self = this;
        this.loadingCalibrations = true;
        InsuranceServices.deleteCalibration(this.calibrationToDelete['id'])
            .then(response => {
                let msg = '';
                if (response && response.data && response.data.message) {
                    msg = response.data.message;
                } else {
                    msg = 'Calibración Eliminada con éxito';
                }
                self.reloadPreviousList();
                self.$_successDeleteRecipients(msg);
                self.removeCalibrationFromList();
                self.loadingCalibrations = false;
                self.reloadViewAllModalDetail();
            })
            .catch(error => {
                this.showMsgError(error);
                self.loadingCalibrations = false;
            });
    }

    removeCalibrationFromList() {
        this.items = removeItemsFromList(this.items, [this.calibrationToDelete], 'id');
    }

    updateCalibration(updatedCalibration) {
        this.loadingCalibrations = true;
        let indexIdToPatch = matchedIndexIdInArray(this.items, updatedCalibration['id']);
        if (indexIdToPatch !== -1) {
            this.$set(this.items[indexIdToPatch], 'date', updatedCalibration['date']);
            this.$set(
                this.items[indexIdToPatch],
                'weight_calibration_factor',
                updatedCalibration['weight_calibration_factor']
            );
            this.$set(
                this.items[indexIdToPatch],
                'humidity_calibration_factor',
                updatedCalibration['humidity_calibration_factor']
            );
            this.$set(this.items[indexIdToPatch], 'weight_variable', updatedCalibration['weight_variable']);
            this.$set(this.items[indexIdToPatch], 'humidity_variable', updatedCalibration['humidity_variable']);
            if (updatedCalibration['using_telemetry'] !== undefined) {
                this.$set(this.items[indexIdToPatch], 'using_telemetry', updatedCalibration['using_telemetry']);
            }
            this.$set(this.items[indexIdToPatch], 'forced_no_telemetry', updatedCalibration['forced_no_telemetry']);
            // this.updateMachineDetailIfDecalibrateValueChanges(this.items[indexIdToPatch]['decalibration_applied'], updatedCalibration['decalibration_applied'])
            this.$set(this.items[indexIdToPatch], 'decalibration_applied', updatedCalibration['decalibration_applied']);
            this.$set(this.items[indexIdToPatch], 'location', updatedCalibration['location']);
            this.$set(this.items[indexIdToPatch], 'delay', updatedCalibration['delay']);
            this.$set(this.items[indexIdToPatch], 'work_width', updatedCalibration['work_width']);
            this.$set(this.items[indexIdToPatch], 'operator', updatedCalibration['operator']);
            this.$set(this.items[indexIdToPatch], 'harvest_type', updatedCalibration['harvest_type']);
            this.$set(this.items[indexIdToPatch], 'function', updatedCalibration['function']);
            this.$set(this.items[indexIdToPatch], 'comments', updatedCalibration['comments']);
            this.$set(this.items[indexIdToPatch], 'calibration_passes', updatedCalibration['calibration_passes']);
            this.$set(this.items[indexIdToPatch], 'active_calibration', updatedCalibration['active_calibration']);
        }
        this.reloadViewAllModalDetail();
        this.loadingCalibrations = false;
    }

    deleteCalibration(calibrationToDelete) {
        this.calibrationToDelete = calibrationToDelete;
        this.setDeleteType('calibration');
        this.showDeleteConfirmationDialog('Eliminar Calibración', '¿Está seguro que desea eliminar esta calibración?');
    }

    variableFormatter(item) {
        if (item !== null) {
            let varDescription = item['description'] !== null ? item['description'] : '';
            return item['variable_id'] + ' - ' + varDescription;
        } else {
            return '-';
        }
    }

    visibleModalViewAll: boolean = false;

    //delete confirmation
    confirmationDelete: boolean = false;
    loadingIgnoredPeriods: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';

    @Emit()
    disabledRowAction(item) {
        return item;
    }

    @Emit()
    updateCalibrationPeriodsAndAreaByDay() {}

    deleteLevMap(levMapToDelete) {
        this.levMapToDelete = levMapToDelete;
        this.setDeleteType('levmap');
        this.showDeleteConfirmationDialog('Eliminar Levantada de Mapa', '¿Está seguro que desea eliminar este CSV?');
    }

    deleteConfiguration(levMapToDelete) {
        this.levMapToDelete = levMapToDelete;
        this.setDeleteType('levmap');
        this.showDeleteConfirmationDialog('Eliminar Levantada de Mapa', '¿Está seguro que desea eliminar este CSV?');
    }

    downloadLevMap(item) {
        this.$set(item, 'isDownloading', true);
        let csvUrl = item['url'];
        InsuranceServices.getArrayBufferFromUrl(csvUrl)
            .then(res => {
                this.$set(item, 'isDownloading', false);
                let actualHour = moment().format('DD-MM-YYYY_HH:mm');
                let company =
                    item['harvest'] && item['harvest']['company'] && item['harvest']['company']['name']
                        ? item['harvest']['company']['name']
                        : null;
                if (company == null) {
                    company = item['harvest']['name'];
                } else {
                    company += '_' + item['harvest']['name'];
                }
                let fileName = company + '_' + 'performance_map' + '_' + actualHour + '.csv';
                downloadFile(fileName, res);
            })
            .catch(err => {
                this.$set(item, 'isDownloading', false);
            });
    }

    setDeleteType(value) {
        this.deleteType = value;
    }

    pendingTable(value) {
        this.loadingTable = value;
    }

    @Emit()
    reloadViewAllModalDetail() {}

    @Emit()
    reloadPreviousList() {}

    @Emit()
    viewAllCalibrations() {}

    visibilityModalViewAll(value) {
        this.visibleModalViewAll = value;
    }

    createNewCalibration() {
        this.patchCalibration = null;
        this.visibilityModalCalibration(true);
    }

    showMsgError(error) {
        let self = this;
        let msg = '';
        if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message;
        } else {
            msg = 'Ocurrió un error';
        }
        this.$_errorAddFilter(msg);
    }

    showDeleteConfirmationDialog(title, msgBody) {
        this.deleteModalTitle = title;
        this.deleteBody = msgBody;
        this.confirmationDelete = true;
    }

    dateFormatter(value) {
        return formattedDate(value);
    }

    formatBoolean(value) {
        return booleanFormatter(value);
    }
}
